import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getClinicalFeatureFailure, getClinicalFeatureSuccess, getClinicalFeatures,resetClinicalFeatureState } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    painAbdomen: {
        type: 'text',
        label: 'Pain abdomen'
    },
    jointPain: {
        type: 'text',
        label: 'Joint Pain'
    },
    galtAbnormality: {
        type: 'text',
        label: 'Galt Abnormality'
    },
    visualImpairment: {
        type: 'text',
        label: 'Visual Impairment'
    },
    lossOfFacialSensation: {
        type: 'text',
        label: 'Loss Of Facial Sensation'
    },
    precociousPuberty: {
        type: 'text',
        label: 'Precocious Puberty'
    },
    proximalMuscleWeakness: {
        type: 'text',
        label: 'Proximal Muscle Weakness'
    },
    endocrineAbnormalityPhpt: {
        type: 'text',
        label: 'Endocrine Abnormality PHPT'
    },
    endocrineAbnormalityHyperthyroidism: {
        type: 'text',
        label: 'Endocrine Abnormality Hyperthyroidism'
    },
    endocrineAbnormalityTio: {
        type: 'text',
        label: 'Endocrine Abnormality TIO'
    },
    endocrineAbnormalityAcromegaly: {
        type: 'text',
        label: 'Endocrine Abnormality Acromegaly'
    },
    endocrineAbnormalityAnyother: {
        type: 'text',
        label: 'Endocrine Abnormality Any Other'
    },
    bonySwelling: {
        type: 'text',
        label: 'Bony Swelling'
    },
    anyOther: {
        type: 'text',
        label: 'Any Other'
    },
}

class ClinicalFeature extends React.Component {

    componentDidMount() {
        this.props.getClinicalFeatureEdit(serverUrls.clinicalFeature + this.props.id + '/');
    }
    componentWillUnmount() {
        this.props.resetClinicalFeatureState();
      }

    render() {
        var url = serverUrls.clinicalFeature + this.props.id + '/';
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>Clinical Feature</h4>
                <br/>
                <Row>
                    <Col sm={{size: 10, offset:2}}>
                        <Row>
                            <Col sm={{size: 10, offset:2}}>
                                <h6>Post-Operative</h6>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2}>
                                <h6>Pre-Operative</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>3 Months</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>6 Months</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>1 year</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>2 year</h6>
                            </Col>
                            <Col sm={2}>
                                <h6>5 year</h6>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <CreateFormInput size={2} label={false} count={6} isPost={false} buttonName="Save" url={url} formName="getClinicalFeature" inputs={formInputs} />
                <br/>
                <br/>
            </Container>
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        getClinicalFeatureEdit: (url) => {
            dispatch(getClinicalFeatures({loading: true}));
            axios.get(url).then((res)=>{
                dispatch(getClinicalFeatureSuccess({loading: false, success: res.data.success, data: res.data}));
            }).catch((err)=>{
                dispatch(getClinicalFeatureFailure({loading: false}));
            });
        },
        resetClinicalFeatureState: () => {
            dispatch(resetClinicalFeatureState());
          },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClinicalFeature);
